import { render, staticRenderFns } from "./PowerRankTable.vue?vue&type=template&id=315c1a53&"
import script from "./PowerRankTable.vue?vue&type=script&lang=js&"
export * from "./PowerRankTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports